// User facing project names
// NOTE: Duplicates must have a space after them, or there will be bugs
const projectList = {
	// usa: "Biotech", // Doesn't work with the modern API
	balticsDemo: "Russia-Baltics",
	bcbs: "BCBS",
	cbp: "CBP",
	craftsman: "CRAFTSMAN",
	gec: "GEC",
	gec_analyst: "GEC Analyst",
	iraq: "Iraq",
	texas23: "USCC Texas 23rd",
	usip: "USIP",
	venezuela: "Venezuela",
	sevenTwenty: "BMA",
	sevenTwenty_uscc: "Texas 23 District",
	sayara: "Venezuela ",
};

export default projectList;
